import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navLinks = [
  { name: 'TOP', to: '/' },
  { name: 'AI業務改善', to: '/services/ai-improvement/' },
  { name: 'AIシステム開発', to: '/services/system-development/' },
  { name: 'AI運用・改善支援', to: '/services/ai-operation/' },
  { name: 'AI集客支援', to: '/services/ai-marketing/' },
  { name: 'Luvira ASA', to: '/services/ai-security/' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkClass = 'text-[#a0a0b0] hover:text-white';

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 h-16 transition-all duration-300 ${
          scrolled
            ? 'bg-[#0d0d1a]/85 backdrop-blur-xl border-b border-[#2a2a3e]'
            : 'bg-transparent border-b border-transparent'
        }`}
      >
        <nav className="h-full max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer shrink-0">
            <img
              src="https://media.genaiweb.ai/1cfcb9a7-5410-444f-8143-602b7e61a697/logo.png"
              alt="株式会社ルヴィラ"
              className="h-10 w-auto brightness-0 invert"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-0.5">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    isActive && link.to !== '/' ? 'text-white font-medium' : linkClass
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <Link
              to="/contact/"
              className="ml-2 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-10 px-5 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] hover:brightness-110 text-white transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_10px_30px_rgba(124,58,237,0.4)] cursor-pointer"
            >
              お問い合わせ
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-white"
            aria-label="メニュー"
          >
            <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </nav>
      </header>

      {/* Mobile overlay */}
      <div
        className={`fixed inset-0 z-40 bg-[#0d0d1a] transition-all duration-300 lg:hidden ${
          mobileOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
        }`}
      >
        <div className="h-full pt-24 px-6 flex flex-col overflow-y-auto">
          <div className="space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="block px-2 py-3 text-xl font-semibold text-white hover:text-[#a78bfa] transition-colors cursor-pointer border-b border-[#2a2a3e]"
              >
                {link.name}
              </Link>
            ))}
          </div>
          <div className="mt-8">
            <Link
              to="/contact/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 w-full text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white cursor-pointer"
            >
              お問い合わせ
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}